module.exports = __webpack_public_path__ + "static/img/ai.5b8a45d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ai.png
// module id = qk6J
// module chunks = 1